/* eslint-disable import/prefer-default-export */
import { isNil } from 'lodash';
import { isTrue } from '@/utils/boolean';
import { isEmpty } from './basic';

export const EMPTY_TEXT = '-';

export const matcher = {
  /* eslint-disable no-useless-escape */
  ipv4() {
    return new RegExp('^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$');
  },
  /* eslint-disable max-len */
  ipv6() {
    return /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/g;
  },
  /* eslint-enable max-len */
  // TODO:  ipv6 추가 필요. 현재 length rule 위반
  macAddr() {
    return new RegExp('^([0-9a-fA-F][0-9a-fA-F][:-]){5}[0-9a-fA-F]{2}$');
  },
  integer() {
    return /^-?\d+$/;
  },
  rationalNumber() {
    return /^-?\d*\.?\d*$/;
  },
  oid() {
    return /^([1-9][0-9]{0,}|0)(\.([1-9][0-9]{0,}|0)){1,}$/g;
  },
  domainName() {
    return new RegExp('(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{1,63}(?<!-).)+[a-zA-Z]{2,63}$)');
  },
  email() {
    return /^(")?(?:[^\."\s])(?:(?:[\.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[\-\w]*\.){1,5}([A-Za-z]){2,6}$/;
  },
  /* eslint-enable no-useless-escape */
};

export function getValueAfterCheckEmpty(value) {
  return isEmpty(value) ? EMPTY_TEXT : value;
}
/**
 * 사이즈에 맞게 값 변환.
 * @author Ju
 * @param  {String} value
 * @return {String}
 */
export function pad(value, size) {
  if (isNil(value)) {
    return null;
  }
  const stringVal = `${value}`;
  if (stringVal.length >= size) {
    return stringVal;
  }
  return new Array((size + 1) - stringVal.length).join('0') + stringVal;
}

export function validate(_matcher, value, allowBlank) {
  if (isEmpty(value)) {
    return !!(isEmpty(allowBlank) || allowBlank);
  }
  return _matcher.test(value);
}
export function validateEmailAddr(value, allowBlank) {
  let isValid = false;
  if (value.length > 0) {
    isValid = validate(matcher.email(), value, allowBlank);
  }
  return isValid;
}

export function validateIpv4(value, allowBlank) {
  return validate(matcher.ipv4(), value, allowBlank);
}

export function validateIpv6(value, allowBlank) {
  return validate(matcher.ipv6(), value, allowBlank);
}

export function validateMacAddress(value, allowBlank) {
  return validate(matcher.macAddr(), value, allowBlank);
}

export function validateInteger(value, allowBlank) {
  return validate(matcher.integer(), value, allowBlank);
}


/**
 * OID에 대한 유효성 검사를 한다.
 * @author Ju
 * @param  {string} value      값
 * @param  {boolean} allowBlank 빈 값 허용 여부. true일 경우 빈 값 허용. false일 경우 빈 값 허용 안 함
 * @return {boolean}            유효성 여부
 */
export function validateOid(value, allowBlank) {
  return validate(matcher.oid(), value, allowBlank);
}

/**
 * 비밀번호 유효성 검사를 한다.
 * @author Ju
 * @param  {String} value            비밀번호
 * @param  {Object} policy           비밀번호 정책 정보 객체
 * @param  {Object} accountInfo 사용자 계정 정보
 * @return {Object}                  { valid: 유효성 여부 (true: 유효 / false: 유효하지 않음), message: '유효성 검사 메시지' }
 */
export function validatePassword(value, policy, accountInfo = {}) {
  if (isEmpty(value)) {
    return {
      valid: false,
      message: '비밀번호를 입력해주세요.',
    };
  } else if (isTrue(policy.SETPASSWORDPOLICY)) {
    // 1. 비밀번호 최소 길이 (MINIMUMLENGTH)
    if (isTrue(policy.USE_MINIMUMLENGTH)) {
      if (value.length < policy.MINIMUMLENGTH) {
        return {
          valid: false,
          message: `비밀번호는 ${policy.MINIMUMLENGTH}자 이상 입력하셔야 합니다.`,
        };
      }
    }

    // 2.비밀번호 최대 길이 (MAXIMUMLENGTH)
    if (isTrue(policy.USE_MAXIMUMLENGTH)) {
      if (value.length > policy.MAXIMUMLENGTH) {
        return {
          valid: false,
          message: `비밀번호는 ${policy.MAXIMUMLENGTH}자 이내로 입력하셔야 합니다.`,
        };
      }
    }

    // 3. 보안 취약 패턴 (SECURITYWEAKPATTERNCHECK)
    // 연속된 글자 등 보안상 취약한 패턴으로 설정했는지 확인한다.
    if (isTrue(policy.SECURITYWEAKPATTERNCHECK)) {
      let pattern = policy.PATTERN.substr(0, policy.PATTERN.length - 1);
      pattern = pattern.replace(/;/g, '|');
      const reg = new RegExp(pattern, 'ig');
      if (reg.test(value)) {
        return {
          valid: false,
          message: '보안에 취약한 패턴은 설정할 수 없습니다.',
        };
      }
    }

    // 4. 문자 / 숫자 조합 필수 여부 (COMBINATIONCHECK)
    // 문자와 숫자를 조합한 값인지 확인한다.
    if (isTrue(policy.COMBINATIONCHECK)) {
      // 문자, 숫자 조합
      const regStr = new RegExp('([ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z])', 'ig');
      const regNum = new RegExp('([0-9])', 'ig');
      if (!regStr.test(value) || !regNum.test(value)) {
        return {
          valid: false,
          message: '문자와 숫자를 조합해 주세요.',
        };
      }
    }

    // 5. 특수 문자 허용 여부 (ALLOWSPECIALCHARACTER)
    // 특수 문자 허용 여부. 허용하지 않으면 특수문자 포함하는지 확인한다.
    if (!isTrue(policy.ALLOWSPECIALCHARACTER)) {
      const reg = new RegExp('[~!@#$%<>^&*()=+_’;."\']', 'ig');
      if (reg.test(value)) {
        return {
          valid: false,
          message: '특수 문자를 포함할 수 없습니다.',
        };
      }
    }

    // 6. 아이디 포함 가능 여부 (ALLOWPASSWORDIDDUPLICATE)
    // 아이디 포함 불가능 할 경우 아이디 포함 여부를 확인한다.
    if (!isTrue(policy.ALLOWPASSWORDIDDUPLICATE)) {
      if (!isEmpty(accountInfo.managerId)) {
        const reg = new RegExp(accountInfo.managerId, 'ig');
        if (reg.test(value)) {
          return {
            valid: false,
            message: '아이디를 포함할 수 업습니다.',
          };
        }
      }
    }

    // 7. 개인정보 포함 가능 여부 (ALLOWPRIVATEINFO)
    // 개인정보 포함이 불가능할 경우 전화번호, 사번 포함 여부를 확인한다.
    if (!isTrue(policy.ALLOWPRIVATEINFO)) {
      if (!isEmpty(accountInfo.telNumber)) {
        const reg = new RegExp(accountInfo.telNumber, 'ig');
        if (reg.test(value)) {
          return {
            valid: false,
            message: '전화번호를 포함할 수 없습니다.',
          };
        }
      }

      if (!isEmpty(accountInfo.empno)) {
        const reg = new RegExp(accountInfo.empno, 'ig');
        if (reg.test(value)) {
          return {
            valid: false,
            message: '사번을 포함할 수 없습니다.',
          };
        }
      }
    }
  }
  return {
    valid: true,
  };
}



// WEBPACK FOOTER //
// ./src/utils/string.js